import type { Api } from "../../data/api";

/**
 * Statusseite zum Löschwunsch über Meta (0156): /datenloeschung?code=TK-…. Meta zeigt diese Adresse der Person, die in Instagram
 * „Daten löschen“ gewählt hat (Antwort der Serverfunktion instagram-data-deletion: { url, confirmation_code }).
 * Die Seite verrät nur den Stand des Vorgangs (public.ig_deletion_status, anonym), nie ein Konto.
 */
export type DeletionState = "completed" | "pending" | "unknown" | "invalid" | "failed";
export interface DeletionStatus {
  state: DeletionState;
  code?: string;
  requested_at?: string | null;
  completed_at?: string | null;
}

export const DELETION_CODE = /^TK-[0-9A-F]{12}$/;
export function normalizeDeletionCode(raw: string | null | undefined): string | null {
  const v = (raw ?? "").trim().toUpperCase();
  return DELETION_CODE.test(v) ? v : null;
}

/** Stand abfragen (immer anonym, auch wenn im Browser jemand angemeldet ist) */
export async function loadDeletionStatus(api: Pick<Api, "rpcAsAnon">, raw: string | null | undefined): Promise<DeletionStatus> {
  const code = normalizeDeletionCode(raw);
  if (!code) return { state: "invalid" };
  try {
    const r = await api.rpcAsAnon<unknown>("ig_deletion_status", { p_code: code });
    const o = (typeof r === "string" ? JSON.parse(r) : r) as DeletionStatus | null;
    if (!o || typeof o.state !== "string") return { state: "failed" };
    return ["completed", "pending", "unknown", "invalid"].includes(o.state) ? o : { state: "failed" };
  } catch {
    return { state: "failed" };
  }
}
